import { useState, useEffect, useCallback } from "react";
import { useAuth } from "../auth/AuthContext";
import { useAuthToken } from "../components/usecontext/AuthContext";
import { encryptTimestamp } from "../components/commoncsrf/csrf-common";
import CommonObj from "../CommonObj";

let _cachedData = null;
let _fetchPromise = null;

export const refreshFieldPermissionsCache = async (accessToken) => {
    _cachedData = null; // Clear old cache
    _fetchPromise = null;

    try {
        const res = await fetch(CommonObj.Endpoints.GetRoleBasedFieldAccess, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
                "X-CSRF-Token": encryptTimestamp(),
            },
        });
        if (!res.ok) throw new Error(`GetRoleBasedFieldAccess: ${res.status}`);
        _cachedData = await res.json(); 
    } catch (error) {
        console.error("Failed to refresh field permissions cache:", error);
    }
};

const useFieldPermissions = (pageName) => {
  const { roleUserId } = useAuth();
  const { accessToken } = useAuthToken();

  const [pageFields, setPageFields] = useState([]);
  const isEdit = true;

  useEffect(() => {
    

    const load = async () => {
      try {
        if (_cachedData) {
          setPageFields(_cachedData.readonlyFields?.[pageName] || []);
          return;
        }
        if (!_fetchPromise) {
          _fetchPromise = fetch(CommonObj.Endpoints.GetRoleBasedFieldAccess, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
              "X-CSRF-Token": encryptTimestamp(),
            },
          }).then((res) => {
            if (!res.ok) throw new Error(`GetRoleBasedFieldAccess: ${res.status}`);
            return res.json();
          });
        }
        const data = await _fetchPromise;
        _cachedData = data;
        setPageFields(data.readonlyFields?.[pageName] || []);
      } catch (error) {
        console.error("useFieldPermissions:", error);
      } finally {
        _fetchPromise = null;
      }
    };

    load();
  }, [accessToken, roleUserId, pageName]);

  
  const isReadOnly = useCallback(
    (fieldName) => {
      return !pageFields.includes(fieldName);
    },
    [pageFields]
  );

  const enableEditMode = useCallback(() => {}, []);

  return { isReadOnly, isEdit, enableEditMode, pageFields };
};

export default useFieldPermissions;
